import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { AuthProvider, RequireAuth } from "./AuthProvider";
import PortalSidebar from "./components/PortalSidebar";
import FahrzeugePage from "./views/FahrzeugePage";
import KampagnenPage from "./views/KampagnenPage";
import FahrtenPage from "./views/FahrtenPage";
import PlatformSettingsPage from "./views/PlatformSettingsPage";
import RechnungenPage from "./views/RechnungenPage";
import ListmonkPage from "./views/ListmonkPage";
import FleetPage from "./views/FleetPage";

const ProtectedLayout = () => (
  <div className="portal-root">
    <PortalSidebar />
    <main className="portal-main">
      <Outlet />
    </main>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RequireAuth fallback={<div className="p-6">Redirecting to login…</div>}>
          <Routes>
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<Navigate to="/fahrzeuge" replace />} />
              <Route path="/fahrzeuge" element={<FahrzeugePage />} />
              <Route path="/fleet" element={<FleetPage />} />
              <Route path="/fleet/new" element={<FleetPage wizard />} />
              <Route path="/fleet/:fleetId" element={<FleetPage />} />
              <Route path="/fahrten" element={<FahrtenPage />} />
              <Route path="/kampagnen" element={<KampagnenPage />} />
              <Route path="/rechnungen" element={<RechnungenPage />} />
              <Route path="/platform" element={<PlatformSettingsPage />} />
              <Route path="/kommunikation" element={<ListmonkPage />} />
            </Route>
          </Routes>
        </RequireAuth>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
